var path = 'app/scripts/modules/core/src/cluster/onDemand/onDemandOptionTemplate.html';
var html = "<a>\n  <account-tag account=\"match.model.account\"></account-tag> <span ng-bind-html=\"match.model.name\"></span>\n</a>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/cluster/onDemand/onDemandOptionTemplate.html
// module id = 969
// module chunks = 0